module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-ellipse-blue-4321363a99291096b1818c14134f3b4a.svg";